import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=5cf1e725&scoped=true&"
import script from "./app-footer.vue?vue&type=script&lang=js&"
export * from "./app-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1e725",
  null
  
)

export default component.exports